<template>
  <section class="cnc-advantage-section">
    <div class="container">
      <div class="text-content">
        <h2 class="section-title">Why XCL for Die Casting</h2>
        <p class="section-subtitle">High-quality die cast components with precision machining and reliable finishing
          solutions.</p>

        <h3 class="feature-title">T1 Samples in as Fast as 7–15 Days</h3>
        <ul class="feature-list">
          <li class="feature-item">
            <svg class="check-icon" width="20" height="20" viewBox="0 0 24 24" fill="none">
              <rect x="3" y="3" width="18" height="18" rx="2" stroke="white" stroke-width="2" />
              <path d="M9 12L11 14L15 10" stroke="white" stroke-width="2" stroke-linecap="round"
                stroke-linejoin="round" />
            </svg>
            <span>Tight Tolerances Down to ±0.01 mm</span>
          </li>
          <li class="feature-item">
            <svg class="check-icon" width="20" height="20" viewBox="0 0 24 24" fill="none">
              <rect x="3" y="3" width="18" height="18" rx="2" stroke="white" stroke-width="2" />
              <path d="M9 12L11 14L15 10" stroke="white" stroke-width="2" stroke-linecap="round"
                stroke-linejoin="round" />
            </svg>
            <span>Support From Prototype to Mass Production</span>
          </li>
          <li class="feature-item">
            <svg class="check-icon" width="20" height="20" viewBox="0 0 24 24" fill="none">
              <rect x="3" y="3" width="18" height="18" rx="2" stroke="white" stroke-width="2" />
              <path d="M9 12L11 14L15 10" stroke="white" stroke-width="2" stroke-linecap="round"
                stroke-linejoin="round" />
            </svg>
            <span>Ideal for Complex & High-Volume Aluminum Parts</span>
          </li>
          <li class="feature-item">
            <svg class="check-icon" width="20" height="20" viewBox="0 0 24 24" fill="none">
              <rect x="3" y="3" width="18" height="18" rx="2" stroke="white" stroke-width="2" />
              <path d="M9 12L11 14L15 10" stroke="white" stroke-width="2" stroke-linecap="round"
                stroke-linejoin="round" />
            </svg>
            <span>No MOQ for Prototype Orders</span>
          </li>
          <li class="feature-item">
            <svg class="check-icon" width="20" height="20" viewBox="0 0 24 24" fill="none">
              <rect x="3" y="3" width="18" height="18" rx="2" stroke="white" stroke-width="2" />
              <path d="M9 12L11 14L15 10" stroke="white" stroke-width="2" stroke-linecap="round"
                stroke-linejoin="round" />
            </svg>
            <span>In-House CNC Machining for Critical Features</span>
          </li>

          <li class="feature-item">
            <svg class="check-icon" width="20" height="20" viewBox="0 0 24 24" fill="none">
              <rect x="3" y="3" width="18" height="18" rx="2" stroke="white" stroke-width="2" />
              <path d="M9 12L11 14L15 10" stroke="white" stroke-width="2" stroke-linecap="round"
                stroke-linejoin="round" />
            </svg>
            <span>Finishing Options: Powder Coating, Anodizing, Plating, Sand Blasting</span>
          </li>
          <li class="feature-item">
            <svg class="check-icon" width="20" height="20" viewBox="0 0 24 24" fill="none">
              <rect x="3" y="3" width="18" height="18" rx="2" stroke="white" stroke-width="2" />
              <path d="M9 12L11 14L15 10" stroke="white" stroke-width="2" stroke-linecap="round"
                stroke-linejoin="round" />
            </svg>
            <span>Full Inspection Before Shipment</span>
          </li>

          <li class="feature-item">
            <svg class="check-icon" width="20" height="20" viewBox="0 0 24 24" fill="none">
              <rect x="3" y="3" width="18" height="18" rx="2" stroke="white" stroke-width="2" />
              <path d="M9 12L11 14L15 10" stroke="white" stroke-width="2" stroke-linecap="round"
                stroke-linejoin="round" />
            </svg>
            <span>Aluminum / Zinc Alloy Die Casting Available</span>
          </li>
        </ul>
      </div>

      <div class="visual-content">
        <img src="@/assets/images/3.jpg" alt="Platform Preview" class="platform-img" />
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'Die_Why'
}
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
}

.cnc-advantage-section {
  width: 100%;
  background: #fff;
  padding: 42px 20px;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 50px;
  align-items: center;
  background: #16bc9c;
  border-radius: 20px;
  padding: 54px 70px;
}

.text-content {
  color: #fff;
}

.section-title {
  font-size: 26px;
  font-weight: 700;
  margin-bottom: 12px;
}

.section-subtitle {
  font-size: 16px;
  opacity: 0.95;
  margin-bottom: 30px;
}

.feature-title {
  font-size: 20px;
  font-weight: 700;
  color: #0f3d36;
  margin-bottom: 20px;
}

.feature-list {
  list-style: none;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.feature-item {
  display: flex;
  align-items: flex-start; /* ✨ 改为 flex-start 适应多行文字 */
  gap: 10px;
  font-size: 16px;
  font-weight: 500;
  line-height: 1.5; /* ✨ 增加行高，提升阅读体验 */
}

.check-icon {
  flex-shrink: 0;
  margin-top: 2px; /* ✨ 微调图标位置，使其与第一行文字对齐 */
}

/* 确保图片自适应容器 */
.platform-img {
  width: 100%;
  max-width: 100%; /* ✨ 防止图片超出容器 */
  height: auto;
  display: block;
  background: transparent;
  object-fit: contain; /* ✨ 保证图片比例不失真 */
}

/* 响应式调整 */
@media (max-width: 1023px) {
  .container {
    grid-template-columns: 1fr;
    gap: 30px; /* 缩小上下两块的间距 */
    /* ✨ 使用 vw 让内边距在手机上自然变小，留出更多空间给图片和文字 */
    padding: clamp(30px, 6vw, 54px) clamp(20px, 5vw, 70px);
  }
  
  .visual-content {
    width: 100%;
    padding: 0; /* 移除额外的 padding，让图片能撑满父容器可用空间 */
    display: flex;
    justify-content: center; /* 确保图片居中 */
  }
}
</style>